/**
 * Keep API collections stable when an endpoint accidentally returns the same
 * entity more than once. Items without an id are retained because there is no
 * safe way to determine whether they are duplicates.
 */
export const dedupeEntities = (items) => {
  if (!Array.isArray(items)) return [];

  const seenIds = new Set();

  return items.filter((item) => {
    const id = item?._id ?? item?.id;
    if (id === undefined || id === null || id === "") return true;

    const normalizedId = String(id);
    if (seenIds.has(normalizedId)) return false;

    seenIds.add(normalizedId);
    return true;
  });
};
